// extracted by mini-css-extract-plugin
export default {"leadershipContainer":"leadership_leadershipContainer__Uj+qm","headings":"leadership_headings__t5V84","profileCardContainer":"leadership_profileCardContainer__t7vNh"};